import React, { useContext, useEffect } from 'react'
import styled from 'styled-components'
import { useIntl, Link } from 'gatsby-plugin-intl'
import { LinkPlaceholder } from 'src/components/Typography'
import routes from 'src/utils/routes'
import HeaderLoggedIn, {
  HeaderGroup
} from 'src/components/header/HeaderLoggedIn'
import { Page } from 'src/components/Wrappers'
import { AddOfferButton } from 'src/components/atoms/Buttons'
import { MENU_ITEMS } from 'src/features/dashboard/duck/consts'
import PermissionsContext from 'src/utils/permissions'
import StockHeader from 'src/features/stocks/components/StockHeader.jsx'
import { EXCHANGE_API_URL_PREFIXES } from 'src/ducks/consts'
import { canAddOffer } from 'src/features/offers/utils/exchangePermissions'
import Drawer from './components/Drawer'
import OfferHistoryDetails from './components/OfferDetails/OfferHistoryDetails'
import useActiveDrawerOffer from './components/OfferDetails/useActiveDrawerOffer'
import GeneralCargoOffersList from './components/lists/GeneralCargoOffersList'
import ExchangeOffersView from './components/map/ExchangeOffersView'
import { EXCHANGE_MAP_TYPES } from './components/map/offerMapUtils'
import { connectGeneral } from './ducks/connectors'
import { ListWrapper, ContentWrapper } from './components/atoms'
import GeneralCargoFilters from './components/filters/GeneralCargo'

const StockGeneralCargo = ({
  className,
  getOffers,
  setDrawerState,
  isDrawerOpen,
  offers,
  pagination,
  selectedOfferId,
  setFilter,
  showOffer,
  stock
}) => {
  const intl = useIntl()
  const {
    drawerOfferType,
    resetDrawerOffer,
    selectDrawerOffer,
    selectHistoryOffer,
    selectedOfferId: activeOfferId,
    selectedOfferType: activeOfferType
  } = useActiveDrawerOffer(EXCHANGE_MAP_TYPES.GENERAL, selectedOfferId)
  const permissions = useContext(PermissionsContext)
  const hasPermissionToAddOffer = canAddOffer(
    EXCHANGE_API_URL_PREFIXES.GENERAL,
    permissions
  )

  useEffect(() => {
    getOffers()
    return () => {
      setDrawerState(false)
    }
  }, [])
  const closeDrawer = () => {
    resetDrawerOffer()
    setDrawerState(false)
  }

  return (
    <Page
      className={className}
      contentPadding={0}
      topBar={
        <HeaderLoggedIn>
          <HeaderGroup withMobileAction={hasPermissionToAddOffer}>
            <StockHeader withDropdown>
              {intl.formatMessage({ id: 'offers.generalCargoExchangeTitle' })}
            </StockHeader>
            {hasPermissionToAddOffer && (
              <Link
                to={`${routes.APP_DASHBOARD}?tab=${MENU_ITEMS.OFFER_FORM_GENERAL}`}
              >
                <AddOfferButton active />
              </Link>
            )}
          </HeaderGroup>
        </HeaderLoggedIn>
      }
    >
      <ContentWrapper>
        <ListWrapper>
          <ExchangeOffersView
            exchangeType={EXCHANGE_MAP_TYPES.GENERAL}
            drawerOfferType={activeOfferType}
            filters={<GeneralCargoFilters />}
            isDrawerOpen={isDrawerOpen}
            onDrawerOfferTypeChange={selectDrawerOffer}
            offers={offers}
            pagination={pagination}
            selectedOfferId={activeOfferId}
            selectedOfferType={activeOfferType}
            setDrawerState={setDrawerState}
            setFilter={setFilter}
            showOffer={showOffer}
            stock={stock}
          >
            <GeneralCargoOffersList trigger={isDrawerOpen} />
          </ExchangeOffersView>
        </ListWrapper>
        <Drawer open={isDrawerOpen} onClose={closeDrawer}>
          <OfferHistoryDetails
            defaultOfferType={EXCHANGE_MAP_TYPES.GENERAL}
            isOpen={isDrawerOpen}
            offerType={drawerOfferType}
            onActiveOfferChange={selectHistoryOffer}
            onClose={closeDrawer}
            onOfferTypeChange={selectDrawerOffer}
            selectedOfferId={`${activeOfferType}:${activeOfferId || ''}`}
          />
        </Drawer>
      </ContentWrapper>
    </Page>
  )
}

const StyledStockGeneralCargo = styled(StockGeneralCargo)`
  ${LinkPlaceholder} {
    margin-bottom: 1.2rem;
  }
`

export default connectGeneral(StyledStockGeneralCargo)
